import React from "react";
import footimg from "../assets/Group (6).png";

function Footer() {
  return (
    <div>
      <div className="footer mt-5">
        <img className="mt-5 ms-5" src={footimg} alt="" />
        <p className="fs-5 text-center">Copyright © 2025, All Rights Reserved.</p>
      </div>
    </div>
  );
}

export default Footer;
